import { Outlet, useNavigate, useLocation } from "react-router-dom";
import keycloak from "../keycloak";

export default function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const fullName =
    keycloak.tokenParsed?.name ||
    keycloak.tokenParsed?.preferred_username;

  const email = keycloak.tokenParsed?.email;

  const menus = [
    {
      label: "Programs",
      path: "/",
      refpath: "/programs",
    },
    {
      label: "Transform Rule",
      path: "/transform-rule",
    },
    {
      label: "Settings",
      path: "/settings",
    },
  ];

  const breadcrumbMap = [
    {
      match: /^\/$/,
      items: [{ label: "Programs", path: "/" }],
    },

    {
      match: /^\/programs\/configs/,
      items: [
        { label: "Programs", path: "/" },
        { label: "Configurations" },
      ],
    },

    {
      match: /^\/programs\/config\/column-mapping/,
      items: [
        { label: "Programs", path: "/" },
        {
          label: "Create Configuration",
          path: "/programs/config",
        },
        { label: "Column Mapping" },
      ],
    },

    {
      match: /^\/programs\/config\/run\/summary/,
      items: [
        { label: "Programs", path: "/" },
        { label: "Run Summary" },
      ],
    },

    {
      match: /^\/programs\/config\/run\/analysis/,
      items: [
        { label: "Programs", path: "/" },
        {
          label: "Run Summary",
          path: "/programs/config/run/summary",
        },
        { label: "Analysis" },
      ],
    },
    {
      match: /^\/programs\/config\/run\/agency\/details/,
      items: [
        { label: "Programs", path: "/" },
        {
          label: "Agency Analysis",
          path: "/programs/config/run/agency",
        },
        { label: "Details" },
      ],
    },
    {
      match: /^\/programs\/config\/run\/agency/,
      items: [
        { label: "Programs", path: "/" },
        {
          label: "Run Summary",
          path: "/programs/config/run/summary",
        },
        { label: "Agency Analysis" },
      ],
    },

    {
      match: /^\/programs\/config\/run\/transaction-review/,
      items: [
        { label: "Programs", path: "/" },
        {
          label: "Run Summary",
          path: "/programs/config/run/summary",
        },
        { label: "Transaction Review" },
      ],
    },

    {
      match: /^\/transform-rule/,
      items: [{ label: "Transform Rule" }],
    },

    {
      match: /^\/settings/,
      items: [{ label: "Settings" }],
    },

    {
      match: /^\/programs\/config/,
      items: [
        { label: "Programs", path: "/" },
        { label: "Create Configuration" },
      ],
    },
  ];

  const breadcrumb =
    breadcrumbMap.find((item) =>
      item.match.test(location.pathname)
    )?.items || [];

  const changePassword = () => {

  
    keycloak.login({
    action: "UPDATE_PASSWORD",
    redirectUri: window.location.origin,
  });
};

  return (
    <div className="bg-background-light font-display text-slate-900 min-h-screen flex flex-col">

      {/* HEADER */}

      <header className="flex items-center justify-between border-b border-slate-200 px-6 py-3 bg-white">

        {/* LEFT */}

        <div className="flex items-center gap-8">

          {/* LOGO */}

          <div
            onClick={() => navigate("/")}
            className="flex items-center gap-3 text-primary cursor-pointer"
          >
             <img width="144px" height="50px" src="../paypromptLogo.svg"/>
            {/* <div className="size-8 flex items-center justify-center bg-primary/10 rounded-lg">
              <span className="material-symbols-outlined">
               
              </span>
            </div>

            <h2 className="text-lg font-bold">
              PayPrompt-Recon
            </h2> */}
          </div>

          {/* MENU */}

          <nav className="hidden md:flex items-center gap-2">

            {menus.map((menu) => {
              const active =
                menu.path === "/"
                  ? location.pathname === "/" ||
                    location.pathname.startsWith(
                      menu.refpath
                    )
                  : location.pathname.startsWith(
                      menu.path
                    );

              return (
                <button
                  key={menu.path}
                  onClick={() => navigate(menu.path)}
                  className={`
                    relative
                    px-3
                    py-2
                    text-sm
                    font-medium
                    transition
                    ${
                      active
                        ? "text-primary after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-full after:bg-primary"
                        : "text-slate-600 hover:text-primary"
                    }
                  `}
                >
                  {menu.label}
                </button>
              );
            })}

          </nav>
        </div>

        {/* RIGHT */}

        <div className="flex items-center gap-4">

          <button className="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center hover:bg-slate-200 transition">
            <span className="material-symbols-outlined">
              notifications
            </span>
          </button>

        {/* <button onClick={changePassword}>
          Change Password
        </button> */}
          <div className="flex items-center gap-3 px-3 py-2 border rounded-lg bg-slate-50">

            <div className="h-9 w-9 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-semibold">
              {fullName?.charAt(0)?.toUpperCase()}
            </div>

            <div className="hidden md:block">
              <div className="text-sm font-semibold">
                {fullName}
              </div>

              <div className="text-xs text-gray-500">
                {email}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* CONTENT */}

      <main className="flex-1 px-6 md:px-10 py-8 max-w-[1440px] mx-auto w-full">

        {/* BREADCRUMB */}

        {/* <div className="mb-6 flex items-center gap-2 text-sm">

          {breadcrumb.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-2"
            >
              {index > 0 && (
                <span className="text-slate-300">
                  /
                </span>
              )}

              {item.path ? (
                <button
                  onClick={() =>
                    navigate(item.path)
                  }
                  className="text-slate-500 hover:text-primary transition"
                >
                  {item.label}
                </button>
              ) : (
                <span className="font-medium text-slate-800">
                  {item.label}
                </span>
              )}
            </div>
          ))}

        </div> */}

        {/* PAGE */}

        <Outlet />

      </main>
    </div>
  );
}